import api from '@/api'
import { defineStore } from 'pinia'
import { computed, ref, watch } from 'vue'
import appQueryClient from '@/libs/appQueryClient'
import useRouteSearchHash from '@/hooks/useRouteSearchHash'

const groupKey = ['group', 'all', 'list']

export const useGroupStore = defineStore('groupStore', () => {
  const group = ref<AnyRecord[]>([])

  const groupEnum = computed(() => {
    return {}
  })

  const set = (newStore) => (group.value = newStore)
  const getRaw = () => group
  const get = () => group.value
  const getEnum = () => groupEnum.value

  const getGroupedData = () =>
    get().reduce((acc: AnyRecord, cur) => {
      acc[cur.type] = [...(acc[cur.type] || []), cur]

      return acc
    }, {})

  const getOptions = (groupName: 'custom' | 'system') => {
    const groupedData = getGroupedData()

    return groupName in groupedData
      ? getGroupedData()[groupName].map((item) => ({ label: item.name, value: item.id }))
      : []
  }

  const refresh = () => appQueryClient.refetchQueries({ queryKey: groupKey })

  const getRemoteData = async () => {
    return appQueryClient.fetchQuery({
      staleTime: Infinity,
      queryKey: groupKey,
      queryFn: () =>
        api.get('/labels', { params: { scene: 'list' } }).then((data) => {
          set(data)
          return data
        }),
    })
  }

  return {
    set,
    get,
    getRaw,
    getEnum,
    refresh,
    getOptions,
    getRemoteData,
    getGroupedData,
  }
})

export const useGroupCurrentStore = defineStore('groupCurrentStore', () => {
  const groupStore = useGroupStore()
  const { currentHashRawText } = useRouteSearchHash()

  const currentGroupName = computed(() => currentHashRawText.value ?? '')
  const currentGroupItem = computed(() =>
    currentGroupName.value
      ? groupStore.get().find((group) => group.name === currentGroupName.value)
      : {},
  )
  const currentId = computed(() => currentGroupItem.value?.id)

  const currenGroupObject = ref(currentGroupItem.value)

  const get = () => currenGroupObject.value
  const getRaw = () => currenGroupObject
  const getId = () => currentId
  const set = (newValue) => (currenGroupObject.value = newValue)

  watch(
    currentGroupName,
    (nValue) =>
      (currenGroupObject.value = groupStore.get().find((group) => group.name === nValue) || {}),
  )

  return {
    get,
    set,
    getId,
    getRaw,
  }
})
